import { hasValue, password } from 'common/validations/field';
import i18n from 'i18n';

const validateLoginForm = (values) => {
  const errors = {};

  if (!hasValue(values.password)) {
    errors.password = i18n.t('emptyField', { ns: 'validations' });
  }

  if (hasValue(values.password) && !password(values.password)) {
    errors.password = i18n.t('password', { ns: 'validations' });
  }

  if (!hasValue(values.password_confirmation)) {
    errors.password_confirmation = i18n.t('emptyField', { ns: 'validations' });
  }

  if (hasValue(values.password) && values.password !== values.password_confirmation) {
    errors.password_confirmation = i18n.t('passwordMatch', { ns: 'validations' });
  }

  return errors;
};

export default validateLoginForm;
